export default __webpack_public_path__ + "static/media/items_xiapu02.c2026a80.jpg";